import { useLocation } from 'react-router'
import { UsersIcon } from '@heroicons/react/24/outline'
import clsx from 'clsx'
import { Link } from '@/components/base/link'

type Section = {
  name: string
  href: string
  icon: typeof UsersIcon
}

interface Props {
  sections: Section[]
}

export const SettingsSection = ({ sections }: Props) => {
  const { pathname } = useLocation()

  return (
    <>
      {
        sections.map(item => (
          <li key={item.name}>
            <Link
              href={item.href}
              className={clsx(
                item.href == pathname
                  ? 'bg-zinc-200 dark:bg-zinc-700 text-zinc-950 dark:text-white' // active
                  : `text-zinc-700 hover:bg-zinc-100 hover:text-zinc-950 dark:text-zinc-200 dark:hover:bg-zinc-800
                     dark:hover:text-white`, // inactive
                'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold',
              )}
            >
              <item.icon
                aria-hidden="true"
                className={clsx(
                  item.href == pathname
                    ? 'text-zinc-950 dark:text-white'
                    : 'text-zinc-700 dark:text-zinc-200 dark:group-hover:text-white group-hover:text-zinc-950',
                  'size-6 shrink-0',
                )}
              />
              {item.name}
            </Link>
          </li>
        ))
      }
    </>
  )
}
